/**
 * @license Copyright (c) Microsoft Corporation.  All rights reserved.
 */
var ConditionalToken = /** @class */ (function () {
    function ConditionalToken() {
    }
    ConditionalToken.If = "#if";
    ConditionalToken.ElseIf = "else if";
    ConditionalToken.Else = "else";
    ConditionalToken.ClosingIf = "/if";
    return ConditionalToken;
}());
export { ConditionalToken };
;
